import { useCallback, useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { completeIntakeForm } from '@api';
import { Interstitial } from '@quickmd-llc/design-system';
import { ArrowRightIcon, Button } from '@quickmd-llc/design-system';
import { Events, tracking } from '@lib/events';
import { BOOKING_CONFIRMATION_ROUTE_PATHNAME } from '@router/routes/routePathnames';
import { ReviewSection } from './ReviewSection';
import { useIntakeForm } from '../../context/useIntakeForm';

export function IntakeFormReview() {
  const { handleEditQuestionResponse, intakeForm, isIntakeFormComplete } =
    useIntakeForm();
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [showInterstitial, setShowInterstitial] = useState<boolean>(false);
  const { questions } = intakeForm;

  useEffect(() => {
    if (isIntakeFormComplete) {
      tracking.trackEvent(Events.VIEW_COMPLETED_INTAKE_FORM);
    } else {
      tracking.trackEvent(Events.VIEW_REVIEW_INTAKE_FORM);
    }
  }, [isIntakeFormComplete]);

  const handleSubmit = async () => {
    if (isIntakeFormComplete) {
      navigate(-1);
      return;
    }

    setIsLoading(true);

    try {
      await completeIntakeForm(intakeForm.intakeFormId);

      tracking.trackEvent(Events.SUBMIT_INTAKE_FORM);

      setShowInterstitial(true);
    } catch (err) {
      // @TODO: Handle error
      console.error(err);
    } finally {
      setIsLoading(false);
    }
  };

  const handleInterstitialFadeOut = useCallback(() => {
    navigate(BOOKING_CONFIRMATION_ROUTE_PATHNAME);
  }, [navigate]);

  return (
    <>
      {showInterstitial && (
        <Interstitial
          onFadeOut={handleInterstitialFadeOut}
          text="Intake form complete!"
        />
      )}

      <div className="flex flex-1 flex-col gap-4">
        <div className="grid gap-6">
          {questions.map((question) => (
            <ReviewSection
              key={question.intakeFormQuestionId}
              question={question}
              onEdit={handleEditQuestionResponse}
            />
          ))}
        </div>

        <Button className="mt-auto" loading={isLoading} onClick={handleSubmit}>
          {isIntakeFormComplete ? (
            'Close'
          ) : (
            <>
              Submit <ArrowRightIcon />
            </>
          )}
        </Button>
      </div>
    </>
  );
}
